module.exports = __webpack_public_path__ + "img/img-3.db749b7a.png";